module.exports = __webpack_public_path__ + "img/BAMFriction-HSV-Generic.2d44cff4.png";